module.exports = __webpack_public_path__ + "img/import.2e2e359c.svg";